<script setup>
import { computed } from 'vue';
import { segmentsFromRanges } from '@/utils/quran/marks';

/** Plain text with [offset, length] ranges painted as <mark>. Never v-html. */
const props = defineProps({
  text: { type: String, required: true },
  ranges: { type: Array, default: () => [] },
});

const segments = computed(() => segmentsFromRanges(props.text, props.ranges));
</script>

<template>
  <template v-for="(segment, i) in segments" :key="i">
    <mark v-if="segment.marked" class="bg-deen-gold/60 text-inherit rounded px-0.5 -mx-0.5">{{ segment.text }}</mark>
    <template v-else>{{ segment.text }}</template>
  </template>
</template>
